module.exports = __webpack_public_path__ + "img/9.c9702a7b.png";